import { yupResolver } from "@hookform/resolvers/yup";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import { DocumentInfo } from "../../../../../../../../models/documents";
import HeaderActions from "./HeaderActions";
import HeaderMetadata from "./HeaderMetadata";
import HeaderTitle from "./HeaderTitle";

interface IDocumentHeaderProps {
    documentInfo: DocumentInfo & Partial<{ date: string }>;
    handleUpdateInfo: (info: DocumentInfo) => void | Promise<void>;
}

const metadataSchema = yup.object().shape({
    document_title: yup.string().required("Título é obrigatório"),
    enterprise: yup.string().required("Empresa é obrigatória"),
    project: yup.string().required("Projeto é obrigatório"),
});

type FormData = {
    document_title: string;
    enterprise: string;
    project: string;
};

export default function DocumentHeader({
    documentInfo,
    handleUpdateInfo,
}: IDocumentHeaderProps) {
    const [isEditing, setIsEditing] = useState(false);

    const { control, handleSubmit, setValue } = useForm<FormData>({
        defaultValues: {
            document_title: documentInfo.document_title,
            enterprise: documentInfo.enterprise,
            project: documentInfo.project,
        },
        resolver: yupResolver(metadataSchema),
    });

    const submit = (data: FormData) => {
        if (isEditing) {
            setIsEditing(false);
            handleUpdateInfo(data);
        } else {
            setIsEditing(true);
        }
    };

    useEffect(() => {
        setValue("document_title", documentInfo.document_title);
        setValue("enterprise", documentInfo.enterprise);
        setValue("project", documentInfo.project);
    }, [documentInfo]);

    return (
        <form onSubmit={handleSubmit(submit)}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "stretch", md: "center" },
                    gap: 2,
                    mb: 3,
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <HeaderTitle
                        title={documentInfo.document_title}
                        isEditing={isEditing}
                        control={control}
                    />

                    <HeaderMetadata
                        company={documentInfo.enterprise}
                        control={control}
                        project={documentInfo.project}
                        date={documentInfo.date!}
                        isEditing={isEditing}
                    />
                </Box>

                <HeaderActions isEditing={isEditing} />
            </Box>
        </form>
    );
}
